export default __webpack_public_path__ + "static/media/service-landing-page.88caf904.png";